import styled from "@emotion/styled";
import { Container, Grid } from "@mui/material";
import React from "react";
import { BuyNow, P, SectionSubHeading, SectionWrapper } from "../../../Styles/style";
import reflect from "../../../../assets/images/about.png"
import TwitterIcon from '@mui/icons-material/Twitter';
import TelegramIcon from '@mui/icons-material/Telegram';
import { useTheme } from "@emotion/react";
const GridHEading = styled(Grid)`
display:flex;
align-items: start;
place-content: ${(props) => (props.pc ? props.pc : "center")};
`;
const GridImage = styled(Grid)`
text-align: left;
`;

const JOiningLinks = styled.img`
  width: 100%;
  height:auto;
  max-width: ${(props) => (props.mw ? props.mw : "700PX")};
  @media screen and (max-width:899px){
    padding:60px 0 0;
 }
`
const S2_Aboutus = () => {
  const theme = useTheme()
  return (
    <div>
      <SectionWrapper p="4rem 0" id="about" >
        <Container maxWidth="xl">
          <Grid container>
            <GridImage item xs={12} md={6} data-aos="fade-right" data-aos-easing="ease-in"
              data-aos-delay="400"
              data-aos-duration="500">
              <SectionSubHeading p599="30PX 0" p="0" m="0"
                data-aos="flip-up"
                data-aos-easing="ease-in"
                data-aos-delay="400"
                data-aos-duration="400"
                data-aos-offset="0"
              >About
              </SectionSubHeading>
              <P maxWidth="88%" p="0 0 40px 0" m="0"
                data-aos="fade-zoom-in"
                data-aos-easing="ease-in"
                data-aos-delay="700"
                data-aos-duration="600"
                data-aos-offset="0"
              >
                Floki, the legendary Norse dog sent from Valhalla, has embarked on a remarkable journey across blockchains in search of the perfect home for his people. Determined and resolute, Floki scours the digital realms, evaluating each blockchain for its potential, driven by the mission to ensure the survival and prosperity of his tribe. After overcoming numerous challenges, his tireless quest leads him to the discovery of PulseChain, the ideal sanctuary. PulseChain offers a vibrant ecosystem, robust infrastructure, and a welcoming community that resonates with Floki's vision. With its advanced technology and unique features, PulseChain provides the fertile ground for his people to thrive, offering scalability, security, and efficiency. In this newfound sanctuary, Floki's people will find not just a home, but a promising future. Their journey from Valhalla to PulseChain stands as a testament to Floki's determination, poised to guide his tribe into a new era of possibilities. As they settle into their abode, they carry the legacy of their past and the limitless potential of their future.
              </P>
              <BuyNow href="https://twitter.com/FlokicoinPulse" target="_blank" LineColor={theme.textSecondary} Color={theme.textSecondary} BgHoverTextColor={theme.textPrimary} BgHoverColors={theme.textSecondary} BgHoverColor={theme.BtnHover}
              ><span /><span /><span /><span /><TwitterIcon style={{ fontSize: "30px" }} />Follow Twitter</BuyNow>
              <BuyNow href="https://t.me/flokicoinpulse" target="_blank" BgHoverTextColor={theme.textSecondary} BgHoverColors={theme.textPrimary} bgColor={theme.textSecondary}>
                <span /><span /><span /><span /><TelegramIcon style={{ fontSize: "30px" }} />Join Telegram</BuyNow>
            </GridImage>
            <GridHEading item xs={12} md={6} data-aos="fade-left" data-aos-easing="ease-in"
              data-aos-delay="400"
              data-aos-duration="500">
              <JOiningLinks loading="lazy" src={reflect} data-aos="fade-zoom-in"
                data-aos-easing="ease-in"
                data-aos-delay="500"
                data-aos-duration="600"
                data-aos-offset="0" />

            </GridHEading>
          </Grid>
        </Container>
      </SectionWrapper>
    </div>
  );
};

export default S2_Aboutus;
